export const ACTIVITY_STATUS_INITIAL: string = 'initial';
export const ACTIVITY_STATUS_DUE_DILIGENCE: string = 'due-diligence';
export const ACTIVITY_STATUS_DEAL_CLOSED: string = 'deal-closed';
export const ACTIVITY_STATUS_REALIZED_INVESTMENTS: string = 'realized-investments';
export const ACTIVITY_STATUS_DEAD_DEAL: string = 'dead-deal';
